// src/asset/components/Footer.js
//import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white text-center py-3 mt-8">
      <p>© {new Date().getFullYear()} Desarrollado por Augusto Rivero. +información: contacto@1montonx2.com</p>
      
    </footer>
  );
}
